import React from 'react';
import { Container } from '@mui/material';
import BCBACalculator from '../components/BCBACalculator';

const BCBAROICalculator = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BCBACalculator />
    </Container>
  );
};

export default BCBAROICalculator;